import React, { useEffect } from "react";

/**
 * Hook that reacts when clicking outside of the passed ref
 * From: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
 */
export function useOutsideAlerter(ref: React.RefObject<HTMLElement>, callback: ()=>void) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event:MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback();
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [callback, ref]);
}
